'use strict';

var angular = require('angular');
var dependencies = ['AVRO.Common.Moment'];
module.exports = angular.module('AVRO.Seasonality.CommonServices', dependencies).factory('SeasonalityCommonService', require('./services/SeasonalityCommonService'));